import {AfterViewInit, Component, inject, input, OnInit, signal, ViewChild} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {AppInputComponent} from '@shared/components/forms/app-input/app-input.component';
import {AlertService} from '@core/services/alert.service';
import {ReactiveFormAbstract} from '@shared/commons/reactive-form-abstract.utils';
import MatchValidator from '@shared/validators/math.validator';
import {AuthApiService} from "@core/services/api/auth-api.service";

@Component({
    selector: 'app-user-change-password-dialog',
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        AppInputComponent
    ],
    templateUrl: './user-change-password-dialog.component.html',
    styleUrl: './user-change-password-dialog.component.scss'
})
export class UserChangePasswordDialogComponent extends ReactiveFormAbstract implements OnInit, AfterViewInit {
    userId = input<number>(0);
    userFirstName = input<string>();
    userLastName = input<string>();

    @ViewChild('passwordInput') passwordInput?: AppInputComponent;

    public activeModal = inject(NgbActiveModal);
    private authApiService = inject(AuthApiService);
    private alertService = inject(AlertService);

    showPassword = signal<boolean>(false);
    showConfirmPassword = signal<boolean>(false);

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.form = this.createForm();
    }

    ngAfterViewInit(): void {
        // Focar no campo de senha após o modal ser renderizado
        setTimeout(() => {
            this.passwordInput?.inputElement?.nativeElement?.focus();
        }, 100);
    }

    protected createForm(): FormGroup {
        return this.fb.group({
            password: ['', [Validators.required, Validators.minLength(6)]],
            confirmPassword: ['', [Validators.required]]
        }, {
            validators: MatchValidator.match('password', 'confirmPassword')
        });
    }

    togglePasswordVisibility(): void {
        this.showPassword.set(!this.showPassword());
    }

    toggleConfirmPasswordVisibility(): void {
        this.showConfirmPassword.set(!this.showConfirmPassword());
    }

    protected submit(): void {
        const password = this.getValue('password');

        this.authApiService.changePassword(this.userId(), password).subscribe({
            next: () => {
                this.alertService.success('messages.success.label', 'Senha alterada com sucesso!');
                this.activeModal.close(true);
            },
            error: () => {
                this.alertService.error('messages.error.label', 'Erro ao alterar senha. Tente novamente.');
            }
        });
    }

    cancel(): void {
        this.activeModal.dismiss();
    }
}

